export const ProviderHttpCommon = {
  key: 'http',
}

export type ProviderHttpAccountType = null
